import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useAcceptOrgInviteMutation } from '@/queries/organizations.queries';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

export function useAcceptInvite() {
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();
	const acceptInviteMutation = useAcceptOrgInviteMutation();
	const toast = useToast();
	const history = useHistory();

	function handleAcceptInviteClick() {
		return acceptInviteMutation
			.mutateAsync({ code: id })
			.then(() => {
				toast({ isClosable: true,
					title: t('Success'),
					description: t('You have successfully joined the organization'),
					status: 'success',
				});

				history.push(ROUTE_DASHBOARD);
			})
			.catch(() => {
				toast({ isClosable: true,
					title: t('Error'),
					description: t('Something went wrong'),
					status: 'error',
				});
			});
	}

	return { t, handleAcceptInviteClick, acceptInviteMutation };
}
